import ExportedImage from 'next-image-export-optimizer';
import Link from 'next/link';

import AnimateWhileInView from '@/components/shared/AnimateWhileInView';

import { siteData } from '@/data/configs/site';
// import discord from '@/public/images/lp/index/discord.png';
// import reddit from '@/public/images/lp/index/reddit.png';
// import telegram from '@/public/images/lp/index/telegram.png';
// import twitter from '@/public/images/lp/index/twitter.png';
import discord from '@/public/img/community/socials/discord.svg';
import linkedin from '@/public/img/community/socials/linkedin.svg';
import telegram from '@/public/img/community/socials/telegram.svg';
import twitter from '@/public/img/community/socials/twitter.svg';
import twitterIcon from '@/public/img/community/socials/twitterIcon.svg';
import youtube from '@/public/img/community/socials/youtube.svg';

const socialIcons = [
  {
    name: 'Discord',
    icon: discord,
    link: siteData.social.discord,
  },
  {
    name: 'Telegram',
    icon: telegram,
    link: siteData.social.telegram,
  },
  {
    name: 'X.com',
    icon: twitter,
    link: siteData.social.twitter,
  },
  {
    name: 'Linkedin',
    icon: linkedin,
    link: siteData.social.linkedin,
  },
  {
    name: 'Youtube',
    icon: youtube,
    link: siteData.social.youtube,
  },
];

export const JoinCommunity = () => {
  return (
    <>
      <section className='my-20 text-center text-white lg:my-24 2xl:my-36'>
        <div className='dummy hidden w-[50.21px] w-[70.21px] lg:w-[125.21px] lg:w-[90.21px]'></div>
        <h2 className='mx-auto mb-[10px] max-w-[756px] font-heading text-3xl font-semibold text-white sm:text-4xl lg:text-5xl'>
          Join the Best Blockchain
          <br /> Community
        </h2>
        <p className='text-base font-normal leading-[18px] -sm:mb-6'>
          Be a Komodian. Contribute, chat and trade among Komodians. Follow our
          <br className='hidden md:block' /> socials to stay updated!
        </p>
        <div className='mx-auto flex w-[341px] flex-row items-center justify-center pt-4 sm:w-[530px] sm:justify-between sm:pt-8 lg:pt-[46px] -sm:flex-wrap -sm:gap-y-8'>
          {socialIcons.map((social, i) => {
            const { name, icon, link, lgWidth, smWidth } = social;
            return (
              <AnimateWhileInView delay={(i + 2) * 0.1} key={social.name}>
                <Link
                  href={link}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='all-index-join_community-discord flex flex-col items-center transition-transform duration-200 ease-in-out hover:scale-110 active:scale-95'
                >
                  <ExportedImage
                    placeholder='empty'
                    src={icon}
                    alt={name}
                    className={`h-[90.8px] w-auto`}
                  />
                </Link>
              </AnimateWhileInView>
            );
          })}
        </div>
      </section>
    </>
  );
};
